<script lang="ts">
	import { navigateToUrl } from 'src/components/Lists/list-helpers';
	import { format } from 'svelte-i18n';

	export let navigationLink;
</script>

<button class="button" on:click={() => navigateToUrl(navigationLink)}>
	<span class="icon-wrapper">
		<i class="button-icon fa-solid fa-cart-shopping" />
	</span>
	<span class="button-text">
		{$format('button_shop_now', { default: 'Shop now' })}
	</span>
</button>

<style>
	.button {
		padding: 16px 32px;
		font-size: 16px;
		font-weight: 500;
		color: #000000;
		background-color: #ffffff;
		border: none;
		border-radius: 200px;
		transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
		user-select: none;
		cursor: pointer;
		text-align: center;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		position: relative;
		box-sizing: border-box;
		transition: all 500ms ease;
		overflow: hidden;
		width: 100%;
		max-width: 350px;
		will-change: transform;
		transform: translateZ(0);
		backface-visibility: hidden;
	}

	.button:active {
		transform: scale(0.97);
	}

	/* Wrapper keeps icon aligned left of text with 10px gap */
	.icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 10px;
		position: relative;
	}

	.button-icon {
		transform: translateY(210%); /* hidden below */
		transition: all 400ms ease;
	}

	/* On hover, rise to normal position */
	.button:hover .button-icon {
		transform: translateY(0);
	}

	.button:hover {
		box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
	}
</style>
